// action
export const ACT_PROCESS_EXPORT_CSV_FILE = "ACT_PROCESS_EXPORT_CSV_FILE";

// mutations
export const SET_PROCESS_EXPORT_CSV_FILE = "SET_PROCESS_EXPORT_CSV_FILE";

// getters
export const GET_PROCESS_EXPORT_CSV_FILE = "GET_PROCESS_EXPORT_CSV_FILE";
